import React from 'react';




export default class item extends React.Component {
    constructor() {
        super();
        this.state = {
            key: ""
        }
    }

    dregreesToRadian(deg) {
        return deg * Math.PI / 180;
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.checkOutGPS &&
            nextProps.local) {
            var R = 6371e3; // metres
            var φ1 = this.dregreesToRadian(nextProps.checkOutGPS.lat);
            var φ2 = this.dregreesToRadian(nextProps.local.Lat);
            var Δφ = this.dregreesToRadian((nextProps.local.Lat - nextProps.checkOutGPS.lat));
            var Δλ = this.dregreesToRadian((nextProps.local.Long - nextProps.checkOutGPS.lon));

            var a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
                Math.cos(φ1) * Math.cos(φ2) *
                Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

            var d = R * c;
            if (d) {
                this.setState({ distanceA: parseInt(d), ready: true });
            }
        }
        if (nextProps.checkInGPS &&
            nextProps.local) {
            var R = 6371e3; // metres
            var φ1 = this.dregreesToRadian(nextProps.checkInGPS.lat);
            var φ2 = this.dregreesToRadian(nextProps.local.Lat);
            var Δφ = this.dregreesToRadian((nextProps.local.Lat - nextProps.checkInGPS.lat));
            var Δλ = this.dregreesToRadian((nextProps.local.Long - nextProps.checkInGPS.lon));

            var a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
                Math.cos(φ1) * Math.cos(φ2) *
                Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

            var d = R * c;
            if (d) {
                this.setState({ distanceB: parseInt(d), ready: true });
            }
        }
    }


    DateToFormattedString(timeStamp) {
        var d = new Date(timeStamp)
        var yyyy = d.getFullYear().toString();
        var mm = (d.getMonth() + 1).toString();
        var dd = d.getDate().toString();
        var hh = d.getHours().toString();
        var mn = d.getMinutes().toString();
        return (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]);
    };

    difference(date2, date1) {
        var dt2 = new Date(date2);
        var dt1 = new Date(date1)
        var hh2 = dt2.getHours().toString();
        var mn2 = dt2.getMinutes().toString();
        var hh1 = dt1.getHours().toString();
        var mn1 = dt1.getMinutes().toString();
        var hh = (hh2-hh1).toString();
        var mn = (mn2-mn1).toString();
        console.log(hh2, hh1, mn2, mn1)
        return (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]);
    }

    render() {
        return (
            <div style={{ height: "60px", width: "60px" }}>
                {
                    this.state.ready ?
                        <div style={this.state.distanceA > 200 || this.state.distanceB > 200 ? { background: "#eb6651", color: "#FFF", padding: "2px" } : { background: "#4dbd74", color: "#FFF", padding: "2px" }}>
                            <div>
                                <i className="fa fa-sign-in" aria-hidden="true"></i>  <b>{this.DateToFormattedString(this.props.checkIn)}</b>
                            </div>
                            <div>
                                <i className="fa fa-sign-out" aria-hidden="true"></i>  <b>{this.DateToFormattedString(this.props.checkOut)}</b>
                            </div>
                            <div>
                                <i className="fa fa-hourglass-end" aria-hidden="true"></i>  <b>{this.difference(this.props.checkOut, this.props.checkIn)}</b>
                            </div>
                        </div>
                        :
                        ""
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/control_de_asistencia/item.js